<template>
  <svg
    class="fi-arrow-icon"
    data-id="fi-arrow-icon"
  >
    <arrows-icon class="fi-arrow-icon__sized" />
  </svg>
</template>

<script setup lang="ts">
import ArrowsIcon from 'svg-icons/arrows.svg';
</script>

<style src="./arrow-icon" />
